import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";

const ServiceFaq: React.FC = () => {
  const { t } = useLanguage();
  const [active, setActive] = useState<number>(1);

  const toggleAccordion = (index: number) => {
    setActive(active === index ? -1 : index);
  };

  const steps = t.serviceDetails.steps;

  return (
    <div className="service-process-wrap pt-120 pb-125">
      <div className="row mt-none-50 align-items-center">
        {/* LEFT SIDE ACCORDION */}
        <div className="col-lg-6 mt-50">
          <h2 className="details-content-title mb-40">
            {t.serviceDetails.methodologyTitle}
          </h2>

          <div className="service_process_faq">
            <div className="accordion">
              {steps.map((item) => (
                <div className="accordion-item" key={item.id}>
                  <div
                    className={`accordion-button ${active === item.id ? "" : "collapsed"}`}
                    role="button"
                    onClick={() => toggleAccordion(item.id)}
                  >
                    {item.title}
                  </div>

                  <div
                    className={`accordion-collapse collapse ${active === item.id ? "show" : ""}`}
                  >
                    <div className="accordion-body">
                      <p className="m-0" style={{ lineHeight: "1.7", color: "rgba(255,255,255,0.8)" }}>
                        {item.content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE CLICKABLE LIST */}
        <div className="col-lg-6 mt-50">
          <ul className="content_layer_group list-unstyled">
            {steps.map((item) => (
              <li
                key={item.id}
                onClick={() => toggleAccordion(item.id)}
                className={active === item.id ? "active" : ""}
                style={{ cursor: "pointer" }}
              >
                <span style={{fontSize : "14px"}}>{item.title.replace(/^\d+\.\s/, "")}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ServiceFaq;